export default __webpack_public_path__ + "static/media/arrow-left-blue.e6cd1dfb.svg";